import { useSwipeable } from "react-swipeable";
import { useNavigate } from "react-router-dom";

const DessertDinner = ({ language }: { language: string }) => {
  const navigate = useNavigate();

  const handlers = useSwipeable({
    onSwipedLeft: () => navigate("/DrinksDinner"),
    onSwipedRight: () => navigate("/MainDinner"),
    trackMouse: true,
    delta: 50,
    trackTouch: true,
  });

  const renderMenuList = (items: any[]) => (
    <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 max-w-4xl w-full shadow-lg mt-8">
      <ul className="space-y-6">
        {items.map((item, index) => (
          <MenuListItem key={index} {...item} language={language} />
        ))}
      </ul>
    </div>
  );

  const desserts = [
    {
      fr: "Crème brûlée",
      en: "Crème Brûlée",
      prixFr: "10$",
      prixEn: "$10",
      descFr:
        "Dessert classique à la crème vanillée onctueuse, recouvert d’une fine couche de sucre caramélisé.",
      descEn:
        "Classic dessert with smooth vanilla custard topped with a thin layer of caramelized sugar.",
    },
    {
      fr: "Pain royal à la crème glacée",
      en: "Royal Bread with Ice Cream",
      prixFr: "14$",
      prixEn: "$14",
      descFr:
        "Pain brioché chaud garni d’une boule de crème glacée, nappé d’un filet de caramel maison.",
      descEn:
        "Warm brioche bread topped with a scoop of ice cream and drizzled with homemade caramel.",
    },
    {
      fr: "Pudding chaud au citron",
      en: "Warm Lemon Pudding",
      prixFr: "12$",
      prixEn: "$12",
      descFr:
        "Pudding moelleux au citron, servi chaud avec une sauce citronnée légèrement sucrée.",
      descEn:
        "Soft lemon pudding served warm with a lightly sweetened lemon sauce.",
    },
  ];

  return (
    <div
      {...handlers}
      className="min-h-screen flex flex-col items-center p-8 bg-cover bg-center bg-fixed pt-[110px]"
      style={{ backgroundImage: "url('/image/Lona2.jpg')" }}
    >
      <p className="text-center text-xs text-green-950 mt-2">
        {language === "fr" ? "Glissez pour naviguer" : "Swipe to navigate"}
      </p>

      {renderMenuList(desserts)}
    </div>
  );
};

const MenuListItem = ({ fr, en, prixFr, prixEn, descFr, descEn, language }: any) => (
  <li className="border-b border-gray-200 pb-6 last:border-0">
    <div className="flex justify-between items-start">
      <div>
        <h3 className="font-bold text-xl">{language === "fr" ? fr : en}</h3>
        <p className="text-gray-600 mt-1 text-sm">{language === "fr" ? descFr : descEn}</p>
      </div>
      <span className="text-green-950 font-medium text-lg whitespace-nowrap ml-4">
        {language === "fr" ? prixFr : prixEn}
      </span>
    </div>
  </li>
);

export default DessertDinner;
